/* eslint-disable max-lines */
import { Action, createReducer, on } from "@ngrx/store";

import * as helpers from "../helpers/chart-helpers";
import { PartsActions } from "./parts.actions";
import { initialState, PartsState } from "./parts.store";

export const partsReducer = createReducer(
  initialState,

  on(PartsActions.getAllComplaints, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllComplaintsSuccess, (state, { complaints }): PartsState => ({
    ...state,
    complaints: complaints,
  })),
  on(PartsActions.getAllComplaintsError, (state, { payload }) => ({
    ...state,
    getAllComplaintsError: payload,
  })),

  on(PartsActions.getAllComplaintsByAdmin, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllComplaintsByAdminSuccess, (state, { complaints }): PartsState => ({
    ...state,
    complaints: complaints,
  })),
  on(PartsActions.getAllComplaintsByAdminError, (state, { payload }) => ({
    ...state,
    getAllComplaintsByAdminError: payload,
  })),

  on(PartsActions.createComplaint, (state, { addComplaintModel }): PartsState => ({
    ...state,
    addComplaintModel: addComplaintModel,
  })),
  on(PartsActions.createComplaintSuccess, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.createComplaintError, (state, { payload }) => ({
    ...state,
    createComplaintError: payload,
  })),

  on(PartsActions.getAll8dNames, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAll8dNamesSuccess, (state, { eightDNames }): PartsState => ({
    ...state,
    eightDNames: eightDNames,
  })),
  on(PartsActions.getAll8dNamesError, (state, { payload }) => ({
    ...state,
    getAll8dNamesError: payload,
  })),

  on(PartsActions.getDownloadComplaintsAsCsv, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getDownloadComplaintsAsCsvSuccess, (state, { csvFile }): PartsState => ({
    ...state,
    csvFile: csvFile,
  })),
  on(PartsActions.getDownloadComplaintsAsCsvError, (state, { payload }) => ({
    ...state,
    getDownloadComplaintsAsCsvError: payload,
  })),

  on(PartsActions.getDownloadComplaintsAsExcel, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getDownloadComplaintsAsExcelSuccess, (state, { excelFile }): PartsState => ({
    ...state,
    excelFile: excelFile,
  })),
  on(PartsActions.getDownloadComplaintsAsExcelError, (state, { payload }) => ({
    ...state,
    getDownloadComplaintsAsExcelError: payload,
  })),

  on(PartsActions.getAllComplaintTableFilterOptions, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllComplaintTableFilterOptionsSuccess, (state, { complaintTableFilterOptions }): PartsState => ({
    ...state,
    complaintTableFilterOptions: complaintTableFilterOptions,
  })),
  on(PartsActions.getAllComplaintTableFilterOptionsError, (state, { payload }) => ({
    ...state,
    getAllComplaintTableFilterOptionsError: payload,
  })),

  on(PartsActions.getAllPartGroups, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllPartGroupsSuccess, (state, { partGroups }): PartsState => ({
    ...state,
    partGroups: partGroups,
  })),
  on(PartsActions.getAllPartGroupsError, (state, { payload }) => ({
    ...state,
    getAllPartGroupsError: payload,
  })),

  on(PartsActions.getAllSupplierComplaintNumbers, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllSupplierComplaintNumbersSuccess, (state, { complaintSupplierComplaintNumbers }): PartsState => ({
    ...state,
    complaintSupplierComplaintNumbers: complaintSupplierComplaintNumbers,
  })),
  on(PartsActions.getAllSupplierComplaintNumbersError, (state, { payload }) => ({
    ...state,
    getAllSupplierComplaintNumbersError: payload,
  })),

  on(PartsActions.getAllErrorCodes, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllErrorCodesSuccess, (state, { errorCodes }): PartsState => ({
    ...state,
    errorCodes: errorCodes,
  })),
  on(PartsActions.getAllErrorCodesError, (state, { payload }) => ({
    ...state,
    getAllErrorCodesError: payload,
  })),

  on(PartsActions.getAllSources, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllSourcesSuccess, (state, { sources }): PartsState => ({
    ...state,
    sources: sources,
  })),
  on(PartsActions.getAllSourcesError, (state, { payload }) => ({
    ...state,
    getAllSourcesError: payload,
  })),

  on(PartsActions.getAllComplaintChartFilterOptions, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getAllComplaintChartFilterOptionsSuccess, (state, { complaintChartFilterOptions }): PartsState => ({
    ...state,
    complaintChartFilterOptions: complaintChartFilterOptions,
  })),
  on(PartsActions.getAllComplaintChartFilterOptionsError, (state, { payload }) => ({
    ...state,
    getAllComplaintChartFilterOptionsError: payload,
  })),

  on(PartsActions.deleteComplaint, (state, { complainId, hashValue }): PartsState => ({
    ...state,
    complainId: complainId,
    hashValue: hashValue,
  })),
  on(PartsActions.deleteComplaintSuccess, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.deleteComplaintError, (state, { payload }) => ({
    ...state,
    deleteComplaintError: payload,
  })),

  on(PartsActions.postReadDataFromPorschePdf, (state, { file }): PartsState => ({
    ...state,
    importFile: file,
  })),
  on(PartsActions.postReadDataFromPorschePdfSuccess, (state): PartsState => ({
    ...state
  })),
  on(PartsActions.postReadDataFromPorschePdfError, (state, { payload }) => ({
    ...state,
    postReadDataFromPorschePdfError: payload,
  })),

  on(PartsActions.getJsonForPartIdentNumber, (state, { partIdentNumber }): PartsState => ({
    ...state,
    partIdentNumber: partIdentNumber,
  })),
  on(PartsActions.getJsonForPartIdentNumberSuccess, (state, { complaintsDetails }): PartsState => ({
    ...state,
    complaintsDetails: complaintsDetails,
  })),
  on(PartsActions.getJsonForPartIdentNumberError, (state, { payload }) => ({
    ...state,
    getJsonForPartIdentNumberError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerShipmentYear, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentYear: {
        ...state.charts.chartCustomerDecisionPerShipmentYear,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerShipmentYearSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentYear: {
        ...helpers.getChartCustomerDecisionPerShipmentYearDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerShipmentYearError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentYear: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerShipmentYearError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerShipmentMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentMonth: {
        ...state.charts.chartCustomerDecisionPerShipmentMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerShipmentMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentMonth: {
        ...helpers.getChartCustomerDecisionPerShipmentMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerShipmentMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerShipmentMonth: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerShipmentMonthError: payload,
  })),

  on(PartsActions.getChartSupplierFeedbackPerShipmentYear, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentYear: {
        ...state.charts.chartSupplierFeedbackPerShipmentYear,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerShipmentYearSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentYear: {
        ...helpers.getChartSupplierFeedbackPerShipmentYearDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerShipmentYearError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentYear: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerShipmentYearError: payload,
  })),


  on(PartsActions.getChartSupplierFeedbackPerShipmentMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentMonth: {
        ...state.charts.chartSupplierFeedbackPerShipmentMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerShipmentMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentMonth: {
        ...helpers.getChartSupplierFeedbackPerShipmentMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerShipmentMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerShipmentMonth: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerShipmentMonthError: payload,
  })),

  on(PartsActions.getChartSupplierFeedbackPerRepairYear, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairYear: {
        ...state.charts.chartSupplierFeedbackPerRepairYear,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerRepairYearSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairYear: {
        ...helpers.getChartSupplierFeedbackPerRepairYearDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerRepairYearError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairYear: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerRepairYearError: payload,
  })),

  on(PartsActions.getChartSupplierFeedbackPerRepairMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairMonth: {
        ...state.charts.chartSupplierFeedbackPerRepairMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerRepairMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairMonth: {
        ...helpers.getChartSupplierFeedbackPerRepairMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerRepairMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerRepairMonth: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerRepairMonthError: payload,
  })),

  on(PartsActions.getChartSupplierFeedbackPerPartProductionYear, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionYear: {
        ...state.charts.chartSupplierFeedbackPerPartProductionYear,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerPartProductionYearSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionYear: {
        ...helpers.getChartSupplierFeedbackPerPartProductionYearDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerPartProductionYearError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionYear: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerPartProductionYearError: payload,
  })),

  on(PartsActions.getChartSupplierFeedbackPerPartProductionMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionMonth: {
        ...state.charts.chartSupplierFeedbackPerPartProductionMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerPartProductionMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionMonth: {
        ...helpers.getChartSupplierFeedbackPerPartProductionMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartSupplierFeedbackPerPartProductionMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartSupplierFeedbackPerPartProductionMonth: {
        isLoading: false
      }
    },
    chartSupplierFeedbackPerPartProductionMonthError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerPartProductionYear, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionYear: {
        ...state.charts.chartCustomerDecisionPerPartProductionYear,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerPartProductionYearSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionYear: {
        ...helpers.getChartCustomerDecisionPerPartProductionYearDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerPartProductionYearError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionYear: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerPartProductionYearError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerPartProductionMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionMonth: {
        ...state.charts.chartCustomerDecisionPerPartProductionMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerPartProductionMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionMonth: {
        ...helpers.getChartCustomerDecisionPerPartProductionMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerPartProductionMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerPartProductionMonth: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerPartProductionMonthError: payload,
  })),

  on(PartsActions.getChartEightDNamePerPartProductionMonth, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartEightDNamePerPartProductionMonth: {
        ...state.charts.chartEightDNamePerPartProductionMonth,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartEightDNamePerPartProductionMonthSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartEightDNamePerPartProductionMonth: {
        ...helpers.getChartEightDNamePerPartProductionMonthDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartEightDNamePerPartProductionMonthError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartEightDNamePerPartProductionMonth: {
        isLoading: false
      }
    },
    chartEightDNamePerPartProductionMonthError: payload,
  })),

  on(PartsActions.getChartPartProductionYearPerSupplierNumber, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartPartProductionYearPerSupplierNumber: {
        ...state.charts.chartPartProductionYearPerSupplierNumber,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartPartProductionYearPerSupplierNumberSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartPartProductionYearPerSupplierNumber: {
        ...helpers.getChartPartProductionYearPerSupplierNumberDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartPartProductionYearPerSupplierNumberError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartPartProductionYearPerSupplierNumber: {
        isLoading: false
      }
    },
    chartPartProductionYearPerSupplierNumberError: payload,
  })),

  on(PartsActions.getChartRepairCountryPerSupplierNumber, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartRepairCountryPerSupplierNumber: {
        ...state.charts.chartRepairCountryPerSupplierNumber,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartRepairCountryPerSupplierNumberSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartRepairCountryPerSupplierNumber: {
        ...helpers.getChartRepairCountryPerSupplierNumberDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartRepairCountryPerSupplierNumberError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartRepairCountryPerSupplierNumber: {
        isLoading: false
      }
    },
    chartRepairCountryPerSupplierNumberError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerVehicleModel, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerVehicleModel: {
        ...state.charts.chartCustomerDecisionPerVehicleModel,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerVehicleModelSuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerVehicleModel: {
        ...helpers.getChartCustomerDecisionPerVehicleModelDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerVehicleModelError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerVehicleModel: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerVehicleModelError: payload,
  })),

  on(PartsActions.getChartCustomerDecisionPerReturnCountry, (state): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerReturnCountry: {
        ...state.charts.chartCustomerDecisionPerReturnCountry,
        isLoading: true
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerReturnCountrySuccess, (state, { chartData }): PartsState => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerReturnCountry: {
        ...helpers.getChartCustomerDecisionPerReturnCountryDataset(chartData),
        isLoading: false
      }
    }
  })),
  on(PartsActions.getChartCustomerDecisionPerReturnCountryError, (state, { payload }) => ({
    ...state,
    charts: {
      ...state.charts,
      chartCustomerDecisionPerReturnCountry: {
        isLoading: false
      }
    },
    chartCustomerDecisionPerReturnCountryError: payload,
  })),

  on(PartsActions.getAllComplaintActiveErrorCodes, (state, { source, supplierNumber }): PartsState => ({
    ...state,
    source: source,
    supplierNumber: supplierNumber,
  })),
  on(PartsActions.getAllComplaintActiveErrorCodesSuccess, (state, { activeErrorCodes }): PartsState => ({
    ...state,
    activeErrorCodes: activeErrorCodes,
  })),
  on(PartsActions.getAllComplaintActiveErrorCodesError, (state, { payload }) => ({
    ...state,
    getAllComplaintActiveErrorCodesError: payload,
  })),

  on(PartsActions.getAllActive8DNamesBySourceAndSupplierNumber, (state, { source, supplierNumber }): PartsState => ({
    ...state,
    source: source,
    supplierNumber: supplierNumber,
  })),
  on(PartsActions.getAllActive8DNamesBySourceAndSupplierNumberSuccess, (state, { rootCauses }): PartsState => ({
    ...state,
    rootCauses: rootCauses,
  })),
  on(PartsActions.getAllActive8DNamesBySourceAndSupplierNumberError, (state, { payload }) => ({
    ...state,
    getAllActive8DNamesBySourceAndSupplierNumberError: payload,
  })),

  on(PartsActions.getDefectivePartAnalysisSupplier, (state, { supplierNumber, partIdentNumber }): PartsState => ({
    ...state,
    supplierNumber: supplierNumber,
    partIdentNumber: partIdentNumber,
  })),
  on(PartsActions.getDefectivePartAnalysisSupplierSuccess, (state, { defectivePartAnalysisSupplier }): PartsState => ({
    ...state,
    defectivePartAnalysisSupplier: defectivePartAnalysisSupplier,
  })),
  on(PartsActions.getDefectivePartAnalysisSupplierError, (state, { payload }) => ({
    ...state,
    getDefectivePartAnalysisSupplierError: payload,
  })),

  on(PartsActions.createErrorCode, (state, { supplierNumber, errorCode, source, errorLabelGerman, errorDescriptionGerman, errorLabelEnglish, errorDescriptionEnglish, errorCodeName, isActive, }): PartsState => ({
    ...state,
    supplierNumber: supplierNumber,
    errorCode: errorCode,
    source: source,
    errorLabelGerman: errorLabelGerman,
    errorDescriptionGerman: errorDescriptionGerman,
    errorLabelEnglish: errorLabelEnglish,
    errorDescriptionEnglish: errorDescriptionEnglish,
    errorCodeName: errorCodeName,
    isActive: isActive
  })),
  on(PartsActions.createErrorCodeSuccess, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.createErrorCodeError, (state, { payload }) => ({
    ...state,
    createErrorCodeError: payload,
  })),

  on(PartsActions.createReferenceReport, (state, { createComplaint8DNameRequest }): PartsState => ({
    ...state,
    createComplaint8DNameRequest: createComplaint8DNameRequest,
  })),
  on(PartsActions.createReferenceReportSuccess, (state): PartsState => ({
    ...state
  })),
  on(PartsActions.createReferenceReportError, (state, { payload }) => ({
    ...state,
    createReferenceReportError: payload,
  })),

  on(PartsActions.createDefectivePartAnalysisSupplier, (state, { supplierNumber, partIdentNumber, source, tab, data, files, transferData }): PartsState => ({
    ...state,
    supplierNumber, partIdentNumber, source, tab, data, files, transferData,
  })),
  on(PartsActions.createDefectivePartAnalysisSupplierSuccess, (state, { defectivePartAnalysisSupplierId }): PartsState => ({
    ...state,
    defectivePartAnalysisSupplierId: defectivePartAnalysisSupplierId
  })),
  on(PartsActions.createDefectivePartAnalysisSupplierError, (state, { payload }) => ({
    ...state,
    createDefectivePartAnalysisSupplierError: payload,
  })),

  on(PartsActions.editDefectivePartAnalysisSupplier, (state, { id, supplierNumber, partIdentNumber, source, tab, data, files, filesForDelete, transferData }): PartsState => ({
    ...state,
    id, supplierNumber, partIdentNumber, source, tab, data, files, filesForDelete, transferData,
  })),
  on(PartsActions.editDefectivePartAnalysisSupplierSuccess, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.editDefectivePartAnalysisSupplierError, (state, { payload }) => ({
    ...state,
    editDefectivePartAnalysisSupplierError: payload,
  })),

  on(PartsActions.downloadFile, (state, { filename, source, partIdentNumber, tab }): PartsState => ({
    ...state,
    filename, source, partIdentNumber, tab
  })),
  on(PartsActions.downloadFileSuccess, (state, { filename, file }): PartsState => ({
    ...state,
    downloadedFiles: {
      ...state.downloadedFiles,
      [filename]: file,
    },
  })),
  on(PartsActions.downloadFileError, (state, { payload }) => ({
    ...state,
    downloadFileError: payload,
  })),

  on(PartsActions.getData4D8D, (state, { partIdentNumber, supplierNumber }): PartsState => ({
    ...state,
    partIdentNumber: partIdentNumber,
    supplierNumber: supplierNumber
  })),
  on(PartsActions.getData4D8DSuccess, (state, { data4D8D }): PartsState => ({
    ...state,
    data4D8D: data4D8D
  })),
  on(PartsActions.getData4D8DError, (state, { payload }) => ({
    ...state,
    getData4D8DError: payload,
  })),

  on(PartsActions.getPartAnalysisData, (state, { supplierNumber, partIdentNumber }): PartsState => ({
    ...state,
    supplierNumber: supplierNumber,
    partIdentNumber: partIdentNumber,
  })),
  on(PartsActions.getPartAnalysisDataSuccess, (state, { partAnalysisData }): PartsState => ({
    ...state,
    partAnalysisData: partAnalysisData,
  })),
  on(PartsActions.getPartAnalysisDataError, (state, { payload }) => ({
    ...state,
    getPartAnalysisDataError: payload,
  })),

  on(PartsActions.getSupplierComplaintNumber, (state, { source, partIdentNumber }): PartsState => ({
    ...state,
    source: source,
    partIdentNumber: partIdentNumber,
  })),
  on(PartsActions.getSupplierComplaintNumberSuccess, (state, { supplierComplaintNumber }): PartsState => ({
    ...state,
    supplierComplaintNumber: supplierComplaintNumber,
  })),
  on(PartsActions.getSupplierComplaintNumberError, (state, { payload }) => ({
    ...state,
    getSupplierComplaintNumberError: payload,
  })),

  on(PartsActions.getComplaintImportHistory, (state): PartsState => ({
    ...state,
  })),
  on(PartsActions.getComplaintImportHistorySuccess, (state, { complaintImportHistoryResponse }): PartsState => ({
    ...state,
    complaintImportHistoryResponse: complaintImportHistoryResponse,
  })),
  on(PartsActions.getComplaintImportHistoryError, (state, { payload }) => ({
    ...state,
    getComplaintImportHistoryError: payload,
  })),

  on(PartsActions.getDiagnosticProtocols, (state, { partIdentNumber, sourceType }): PartsState => ({
    ...state,
    partIdentNumber: partIdentNumber,
    source: sourceType,
  })),
  on(PartsActions.getDiagnosticProtocolsSuccess, (state, { diagnosticProtocols }): PartsState => ({
    ...state,
    diagnosticProtocols: diagnosticProtocols,
  })),
  on(PartsActions.getDiagnosticProtocolsError, (state, { payload }) => ({
    ...state,
    getDiagnosticProtocolsError: payload,
  })),
);

export function reducer(state: PartsState | undefined, action: Action) {
  return partsReducer(state, action);
}
